import { apiUrl } from '../config/api';

export interface ContactMessagePayload {
  firstName: string;
  lastName: string;
  email: string;
  subject: string;
  message: string;
}

export const sendContactMessage = async (payload: ContactMessagePayload): Promise<Response> => {
  const params = new URLSearchParams({
    fname: payload.firstName,
    lname: payload.lastName,
    email: payload.email,
    subject: payload.subject,
    message: payload.message
  });

  return fetch(apiUrl(`/contact?${params.toString()}`));
};

export const fetchWhichPangoStats = async (choice: string): Promise<any> => {
  const response = await fetch(apiUrl(`/whichpango?pango=${encodeURIComponent(choice)}`));
  return response.json();
};

export const sendNewsletterSignup = async (email: string): Promise<Response> => {
  return fetch(apiUrl('/newsletter'), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ email })
  });
};